module.exports = __webpack_public_path__ + "img/menu-bg7.2d1cab34.png";